import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const REPORTING_SEED = { key: '' } as const;

/**
 * @param formData - Whatever the shared form bag currently holds.
 * @returns The reporting password string, or an empty string when it is absent.
 */
export const reportingPasswordFromForm = (formData: unknown): string => {
  if (typeof formData !== 'object' || formData === null || Array.isArray(formData)) {
    return '';
  }
  const password = (formData as { key?: unknown }).key;
  return typeof password === 'string' ? password : '';
};

/**
 * @param value - Stored or in-progress reporting form value.
 * @returns True when the only property is a string `key`.
 */
export const isReportingValue = (value: unknown): value is { key: string } => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false;
  }
  const record = value as Record<string, unknown>;
  return Object.keys(record).length === 1 && typeof record.key === 'string';
};

const ReportingFields: React.FC<{
  formData: unknown;
  setFormData: (value: { key: string }) => void;
  setJsonValid: (valid: boolean) => void;
}> = ({ formData, setFormData, setJsonValid }) => {
  const password = reportingPasswordFromForm(formData);
  const passwordValid = password.trim().length > 0;

  return (
    <Form.Group as={Row} className="mb-3" controlId="reportingPassword">
      <Form.Label column sm="2">
        Password
      </Form.Label>
      <Col sm="10">
        <Form.Control
          type="password"
          name="key"
          autoComplete="new-password"
          value={password}
          isInvalid={!passwordValid}
          onChange={(event) => {
            const next = event.target.value;
            setFormData({ key: next });
            setJsonValid(next.trim().length > 0);
          }}
        />
        <Form.Text className={passwordValid ? 'text-muted' : 'text-danger'}>
          {passwordValid
            ? 'Password used when reporting is first enabled. A later change does not update the existing Norscom_Readonly role.'
            : 'Password is required.'}
        </Form.Text>
      </Col>
    </Form.Group>
  );
};

export default ReportingFields;
